import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchReferCommissionAndDiscountHistoryList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        const { tabName, userID, searchFilter } = data;

        // Build the URL with optional parameters
        let url = `referandearn/commissions-and-discounts-history/list?tabName=${tabName}`;

        // Add userID and searchFilter only if they are provided
        if (userID) {
            url += `&userID=${userID}`;
        }
        if (searchFilter) {
            url += `&searchFilter=${searchFilter}`;
        }

        // Perform the GET request
        return await get(url);
    }, options);
};